import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isBulkActionsRedesignEnabled"];
import { useCallback } from 'react';
import { RemoveIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import Small from 'UIComponents/elements/Small';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, getSelectedRowIds, selectQuery } from '../redux/selectionSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function BulkActionsContainerOld({
  BulkActionsComponent,
  totalRowCount
}) {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const dispatch = useTableDispatch();
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "bulk-actions-container",
    flexGrow: "1",
    paddingInline: "200",
    children: [/*#__PURE__*/_jsx(Small, {
      className: "p-right-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.bulkActions.selectionCount",
        options: {
          count
        }
      })
    }), /*#__PURE__*/_jsx(BulkActionsComponent, {
      selection: selectedRowIds,
      querySelected: isQuerySelected,
      clearSelection: clearAllSelections
    })]
  });
}
function BulkActionsContainerNew({
  BulkActionsComponent,
  showSelectQuery,
  totalRowCount
}) {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const dispatch = useTableDispatch();
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  const selectEverything = useCallback(() => dispatch(selectQuery()), [dispatch]);
  const count = isQuerySelected ? totalRowCount : selectedRowIds.size;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "bulk-actions-container",
    flexGrow: "1",
    justifyContent: "space-between"
    /*
     * Note: Due to IconButton + Icon component limitations around inline margin specification,
     * we implement a workaround using paddingInlineStart and a subsequent Spacer component
     * to achieve the desired spacing layout.
     */,
    paddingInlineStart: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: unescapedText('datatable.bulkActions.selectionCount', {
        count
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      display: "inline-block",
      space: "1000"
    }), /*#__PURE__*/_jsxs(Flex, {
      flexGrow: "1",
      children: [showSelectQuery ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "bulk-actions-select-query",
          onClick: selectEverything,
          use: "transparent",
          children: unescapedText('datatable.bulkActions.selectQuery_NoPeriod', {
            count: totalRowCount
          })
        }), /*#__PURE__*/_jsx(Spacer, {
          display: "inline-block",
          space: "200"
        })]
      }) : null, /*#__PURE__*/_jsx(BulkActionsComponent, {
        clearSelection: clearAllSelections,
        querySelected: isQuerySelected,
        selection: selectedRowIds
      })]
    }), /*#__PURE__*/_jsx(Spacer, {
      display: "inline-block",
      space: "1000"
    }), /*#__PURE__*/_jsx(IconButton, {
      onClick: clearAllSelections,
      tooltip: unescapedText('datatable.bulkActions.clearSelection_NoPeriod'),
      use: "transparent",
      children: /*#__PURE__*/_jsx(RemoveIcon, {
        color: "text-core-default"
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      display: "inline-block",
      space: "50"
    })]
  });
}
function BulkActionsContainer(_ref) {
  let {
      isBulkActionsRedesignEnabled = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (isBulkActionsRedesignEnabled) {
    return /*#__PURE__*/_jsx(BulkActionsContainerNew, Object.assign({}, rest));
  }
  return /*#__PURE__*/_jsx(BulkActionsContainerOld, Object.assign({}, rest));
}
export default BulkActionsContainer;